(function () {
  if (!window.ccTrack) return;

  function cardCtx(el) {
    var card = el.closest && el.closest('.cc-card');
    if (card) {
      // Recently-viewed renders cards client-side without the data-cc-vendor/
      // data-cc-title attributes the Liquid snippet adds — fall back to the
      // visible text so that carousel isn't silently context-less.
      var title = card.dataset.ccTitle || card.querySelector('.cc-card__t')?.textContent?.trim() || null;
      var vendor = card.dataset.ccVendor || card.querySelector('.cc-card__v')?.textContent?.trim() || null;
      return { product_handle: card.dataset.ccHandle || null, product_title: title, brand: vendor };
    }
    if (window.ccProduct) return { product_handle: window.ccProduct.handle, product_title: window.ccProduct.title, brand: window.ccProduct.vendor };
    return {};
  }

  // Which PDP carousel a card lives in, when it lives in one — lets "Add to
  // Cart from the PDP" be told apart from "clicked through from You May Also
  // Like / More from Vendor / Recently Viewed / Bumper Sale".
  var PDP_CAROUSELS = [
    ['.cc-mfv', 'more_from_vendor'],
    ['.product-recommendations', 'you_may_also_like'],
    ['.cc-rv', 'recently_viewed'],
    ['.cc-bs', 'bumper_sale'],
  ];
  function pdpCarouselOf(el) {
    for (var i = 0; i < PDP_CAROUSELS.length; i++) if (el.closest(PDP_CAROUSELS[i][0])) return PDP_CAROUSELS[i][1];
    return null;
  }

  function sourceOf(el) {
    if (el.closest('.sticky-add-to-cart')) return 'sticky_bar';
    if (el.closest('#quick-add-modal-content') || el.closest('quick-add-dialog')) return 'quick_add';
    if (el.closest('.cc-card')) return 'card';
    return 'pdp';
  }

  // Add to cart — delegated, scoped to the actual submit control so quantity
  // +/- buttons inside the same form never get mistaken for an add.
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest(
      'form[data-type="add-to-cart-form"] button[type="submit"], form[data-type="add-to-cart-form"] [name="add"]'
    );
    if (addBtn) window.ccTrack('add_to_cart', Object.assign({ source: sourceOf(addBtn), section: pdpCarouselOf(addBtn) }, cardCtx(addBtn)));
  }, true);

  // Buy it now — GoKwik's one-click-checkout script claims this button
  // (data-gokwik-processed="true", data-gokwik-function="buyNow") the same
  // way it claims the cart-drawer checkout button, and stops the 'click'
  // event at the window level before any document 'click' listener here
  // ever sees it (confirmed live via Playwright — 0 tracked clicks on a
  // real click). Same fix as the cart-drawer checkout tracker: listen on
  // 'pointerdown' instead, which GoKwik doesn't touch; 'click' stays only
  // as a deduped fallback for keyboard activation.
  var ccLastBuyNowTrackAt = 0;
  function ccTrackBuyNow(buyNow) {
    var now = Date.now();
    if (now - ccLastBuyNowTrackAt < 1000) return;
    ccLastBuyNowTrackAt = now;
    window.ccTrack('buy_now', Object.assign({ source: sourceOf(buyNow), section: pdpCarouselOf(buyNow) }, cardCtx(buyNow)));
  }
  document.addEventListener('pointerdown', function (e) {
    var buyNow = e.target.closest('.shopify-payment-button, [data-shopify="payment-button"]');
    if (buyNow) ccTrackBuyNow(buyNow);
  }, true);
  document.addEventListener('click', function (e) {
    var buyNow = e.target.closest('.shopify-payment-button, [data-shopify="payment-button"]');
    if (buyNow) ccTrackBuyNow(buyNow);
  }, true);

  // Cart drawer open/close — native <dialog open> attribute, no hook into
  // Horizon's own drawer component internals needed. close carries `value` =
  // ms the drawer was open, the dwell-time signal for the mini-cart analytics.
  var cartDialog = document.getElementById('cart-drawer');
  if (cartDialog) {
    var wasOpen = cartDialog.hasAttribute('open');
    var openedAt = null;
    new MutationObserver(function () {
      var isOpen = cartDialog.hasAttribute('open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) {
        openedAt = window.__ccDrawerOpenedAt = Date.now();
        window.ccTrack('cart_drawer_open', {});
      } else {
        window.ccTrack('cart_drawer_close', { value: openedAt ? Date.now() - openedAt : null });
        openedAt = window.__ccDrawerOpenedAt = null;
      }
    }).observe(cartDialog, { attributes: true, attributeFilter: ['open'] });
  }

  // Card impressions — once per card actually scrolled into view (not just
  // present in a long collection grid's DOM). Recently-viewed renders its
  // cards after an async fetch, so this re-scans for newly-added cards
  // rather than relying on one scan at page load. Each card is tagged with
  // data-cc-obs the moment it's picked up (not when it fires), so a re-scan
  // can never register the same card into two separate observers.
  var cardImpressionIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          cardImpressionIO.unobserve(entry.target);
          window.ccTrack('card_impression', Object.assign({ section: pdpCarouselOf(entry.target), position: listPositionOf(entry.target) }, cardCtx(entry.target)));
        });
      }, { threshold: 0.5 })
    : null;
  function wireCardImpressions() {
    if (!cardImpressionIO) return;
    document.querySelectorAll('.cc-card:not([data-cc-obs])').forEach(function (el) {
      el.setAttribute('data-cc-obs', '1');
      cardImpressionIO.observe(el);
    });
  }
  wireCardImpressions();
  if (document.querySelector('.cc-rv')) setTimeout(wireCardImpressions, 1500); // recently-viewed loads async

  // Card clicks — the actual tap through to a PDP, distinct from an impression.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cc-card a[href]');
    if (!link) return;
    var card = link.closest('.cc-card');
    if (!card) return;
    window.ccTrack('card_click', Object.assign({ section: pdpCarouselOf(card), position: listPositionOf(card) }, cardCtx(card)));
  }, true);

  // "View all" links on the PDP's own carousels (More from Vendor, etc).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cc-mfv__head a, .cc-rv__head a, .cc-bs__head a');
    if (!link) return;
    window.ccTrack('nav_click', { page: link.getAttribute('href') || null, section: pdpCarouselOf(link) });
  }, true);

  // Wishlist — cc-wishlist.js owns the toggle logic; hook its public API
  // rather than duplicating the click handling.
  if (window.ccWishlist && !window.ccWishlist.__tracked) {
    var origToggle = window.ccWishlist.toggle;
    window.ccWishlist.toggle = function (handle) {
      var nowOn = origToggle(handle);
      var card = document.querySelector('.cc-card[data-cc-handle="' + handle + '"]');
      window.ccTrack(nowOn ? 'wishlist_add' : 'wishlist_remove', {
        product_handle: handle,
        product_title: card ? card.dataset.ccTitle : (window.ccProduct && window.ccProduct.handle === handle ? window.ccProduct.title : null),
        brand: card ? card.dataset.ccVendor : (window.ccProduct && window.ccProduct.handle === handle ? window.ccProduct.vendor : null),
      });
      return nowOn;
    };
    window.ccWishlist.__tracked = true;
  }

  // Nav — header menu links and the category strip under the header.
  document.addEventListener('click', function (e) {
    var navLink = e.target.closest('.cc-strip a, header-menu a, .header-menu a');
    if (!navLink) return;
    window.ccTrack('nav_click', { page: navLink.getAttribute('href') || null, section: navLink.closest('.cc-strip') ? 'category_strip' : 'header_menu' });
  }, true);

  // Search opened (distinct from search_use, which cc-search.js fires per
  // actual query once the customer settles on a term).
  document.addEventListener('click', function (e) {
    if (e.target.closest('[aria-label*="Search" i], .header-actions__action--search')) window.ccTrack('search_open', {});
  }, true);

  // ── Size/variant demand signal ──────────────────────────────────────────
  // Fashion retail treats a sold-out-size click as real demand data, not
  // nothing — raw sales alone can't distinguish "nobody wants this size"
  // from "we were out of stock the whole time nobody could buy it" (the
  // "phantom demand" problem). Horizon's variant picker already puts
  // data-option-available on every size input — just needed reading.
  document.addEventListener('click', function (e) {
    var input = e.target.closest('.variant-picker input[data-option-value-id]');
    if (!input) return;
    var available = input.dataset.optionAvailable === 'true';
    window.ccTrack(available ? 'variant_select' : 'variant_unavailable_click', Object.assign({
      section: input.value || null, // the size/value itself (e.g. "M", "Black")
      source: input.dataset.optionName || null, // which option this is (Size, Colour, ...)
    }, cardCtx(input)));
  }, true);

  // ── List position ────────────────────────────────────────────────────
  // Which position in a grid/carousel a card sits at, so "do people buy
  // what's at the top of a collection or do they actually scroll" is
  // answerable — GA4/Segment both treat list+index as core context for a
  // product impression/click, not an afterthought.
  function listPositionOf(card) {
    var grid = card.parentElement;
    if (!grid) return null;
    var siblings = Array.prototype.filter.call(grid.children, function (c) { return c.classList && c.classList.contains('cc-card'); });
    var idx = siblings.indexOf(card);
    return idx > -1 ? idx + 1 : null; // 1-based — reads naturally as "position 1" not "position 0"
  }

  // ── Rage clicks ──────────────────────────────────────────────────────
  // 3+ clicks on the exact same element within ~1.2s almost always means
  // "this looks clickable but nothing happened" — a real UX/bug signal
  // distinct from normal browsing, cheap to detect client-side.
  var rageTarget = null, rageCount = 0, rageTimer = null;
  document.addEventListener('click', function (e) {
    var el = e.target.closest('button, a, [role="button"], input[type="submit"]');
    if (!el) return;
    if (el === rageTarget) {
      rageCount++;
    } else {
      rageTarget = el; rageCount = 1;
    }
    clearTimeout(rageTimer);
    rageTimer = setTimeout(function () { rageTarget = null; rageCount = 0; }, 1200);
    if (rageCount === 3) {
      var label = (el.getAttribute('aria-label') || el.textContent || '').trim().slice(0, 60) || null;
      window.ccTrack('rage_click', { section: label, page: location.pathname });
    }
  }, true);
})();
